import React from 'react';
import styled from 'styled-components';
import { minBp } from 'src/lib/theme';
import _Input from 'components/_form/Input/Input';
import { buttonStyles } from 'components/Button/Button';

export const Wrap = styled.div`
  padding: 55px 30px 30px;

  @media ${minBp('tablet')} {
    padding: 75px 60px 60px;
    width: 650px;
  }

  @media ${minBp('tabletLarge')} {
    width: 800px;
  }
`;

export const H4 = styled.h4`
  text-transform: uppercase;
  margin-bottom: 7px;
`;

export const Tagline = styled.p`
  margin-bottom: 15px;
`;

export const Partition = styled.div`
  border-top: 1px solid #eee;
  padding: 30px 0 0;

  @media ${minBp('tablet')} {
    padding: 30px 5px 0;
  }
`;

export const InputTagline = styled.div`
  color: #585a5f;
  font-size: 12px;
  line-height: 19px;
  margin-bottom: 10px;
  font-family: ${({ theme }) => theme.fonts.dinDemi};

  @media ${minBp('desktop')} {
    font-size: 14px;
    line-height: 22px;
  }

  * {
    font-size: inherit;
    line-height: inherit;
    color: inherit;

    &:before {
      color: inherit;
    }
  }
`;

export const Input = styled(_Input)`
  display: block;
  margin-bottom: 15px;
  width: 100%;

  @media ${minBp('tabletLarge')} {
    width: 530px;
  }
`;

export const SocialIcons = styled.div`
  margin-bottom: 25px;
`;

export const SocialIcon = styled.a`
  margin-right: 25px;
  width: 35px;
  height: 35px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;

  img {
    height: 25px;
    width: auto;
    pointer-events: none;

    @media ${minBp('tablet')} {
      height: 30px;
    }
  }
`;

export const CopyButton = styled.button`
  ${buttonStyles};
`;
